import React from 'react';

import { IS_SERVER } from '@blush/constants';

export const useLayoutEffect = IS_SERVER ? React.useEffect : React.useLayoutEffect;
